import { useMemo } from 'react';
import { useLang } from '../context/LanguageContext';
import { getLocale } from '../data/localized';

export function useContent() {
  const { lang } = useLang();
  return useMemo(() => getLocale(lang), [lang]);
}
